import React from 'react'
import styled from '@emotion/styled'
import {
    widgets,
    WidgetCategories,
    AddableWidget,
} from '../../../../../../spark_libs_deprecated/feature-dashboard-widgets'
import AddWidgetItem from './AddWidgetItem'
import { useRoles, checkRoles, useGlobalAdminCheck } from '@edge/spark/io-roles'
import { useFlags } from 'launchdarkly-react-client-sdk'
import { evaluateFeatureFlags } from '@edge/spark/io-dashboards'

const Container = styled.div`
    box-sizing: border-box;
    width: 100%;
    background-color: '#FAFAFA';
`

// interface Props {
//     widgetDef: DashboardCardDef
//     handleSaveConfig: (cardDef: DashboardCardDef) => void
//     handleClose: () => void
//   }

//   const SearchVehicleStatsConfigurationModal: React.FC<Props> = ({
//     widgetDef,
//     handleClose,
//     handleSaveConfig,
//   }: Props) => {

// interface Props {
//     widgetDef: DashboardCardDef
//     handleSaveConfig: (cardDef: DashboardCardDef) => void
//     handleClose: () => void
//   }

const AddDashboardComponent = (): React.ReactElement => {
    const flags = useFlags()
    const selectedCategory = WidgetCategories.SEARCH
    const roles = useRoles()
    const isEdgeAdmin = useGlobalAdminCheck()
    // TODO: Add category picker

    // casting should be ok since we've type checked: 'categories' in widget
    const widgetsToShow = widgets.filter((widget) => {
        if (widget?.featureFlags) {
            const { include = [], exclude = [] } = widget.featureFlags
            return evaluateFeatureFlags({include, exclude, flags})
        }

        if ('categories' in widget && widget?.categories.includes(selectedCategory)) {
            if (isEdgeAdmin) {
                return true
            }
            if (widget.requiredRoleOption && widget.requiredRoleOption?.length > 0) {
                const { requiredRoleOption } = widget
                if (!roles || roles.length === 0) {
                    return false
                }
                const response = checkRoles(roles, requiredRoleOption)
                if (!response) {
                    return false
                }
            }

            return true
        }

        return false
    }) as AddableWidget[]

    return (
        <Container>
            {/* <StyledTypography variant="body2">
        To add a component, click and drag it onto the screen
      </StyledTypography> */}
            {widgetsToShow.map((widget) => (
                <AddWidgetItem widget={widget} key={widget.name} />
            ))}
        </Container>
    )
}

export default AddDashboardComponent
